import React, { useContext, useState } from "react";
import SingleSelectDropDown from "../../../layouts/SingleSelectDropDown";
import FormTriggers from "../../../layouts/FormTriggers";
import RadioButtons from "../../../layouts/RadioButtons";
import { axios_instance } from "../../../api/axios_instance";
import FormButtons from "./FormButtons";
import { toast } from "react-toastify";
import {
  checkHoldCase,
  getCompletedStepDetails,
  holdCaseMessage,
  rtoParticularsValidate,
} from "../../../utils/detail";
import { DetailFormContext } from "../../../ContextAPI/context";

const RtoDetailsCheck = ({
  fieldValues,
  stepSelected,
  handleNextStep,
  user,
  isVerificationRequired,
  Message,
  dtsCheckpoints,
  fetchCaseData,
  caseDetails,
}) => {
  const { panelTitle, stepTitle, setDetailFormButtonClicked } =
    useContext(DetailFormContext);
  const { stepDetails, visibilityObj, requiredSubStepFields } = fieldValues;
  const { checklist, btnDraftType, total_tranche } = stepDetails;

  const {
    finance_lead_id,
    id,
    stage,
    sub_stage,
    insurance,
    bank_id,
    is_prepayment_raised,
    is_hpt,
    is_hpa,
    rcm_hpt,
    rcm_hpa,
    is_noc,
    is_name_transfer,
    is_inter_rto_transfer,
    step_details,
    maker_id,
  } = caseDetails;

  const initialState = {
    HPT: is_hpt || rcm_hpt,
    HPA: is_hpa || rcm_hpa,
    nocAmountTranche: caseDetails.noc_amount_tranche,
    NOCRequired: is_noc,
    isNameTransfer: is_name_transfer,
    isInterRTOTransfer: is_inter_rto_transfer,
    showHPTError: false,
    showHPAError: false,
    showNocAmountTrancheError: false,
    showNocRequiredError: false,
    showIsNameTransferError: false,
    showIsInterRTOTransfer: false,
  };

  const [state, setState] = useState(initialState);

  const showNocTranche = +state.NOCRequired !== 1 ? false : true;

  const total_tranches = total_tranche && total_tranche > 2 ? total_tranche : 5;

  const NocAmountTranche = [{ text: "Select Tranche", value: "" }];

  for (let i = 1; i <= total_tranches; i++) {
    NocAmountTranche.push({ text: i + 1, value: i + 1 });
  }

  // Check visibility conditions for each field
  const isRtoLocationVisible =
    requiredSubStepFields?.rto_location?.is_visible === 1;
  const isRtoNameVisible = requiredSubStepFields?.rto_name?.is_visible === 1;
  const isHptApplicableVisible =
    requiredSubStepFields?.hpt_applicable?.is_visible === 1;

  const isHpaApplicableVisible =
    requiredSubStepFields?.hpa_applicable?.is_visible === 1;
  const isNocRequiredVisible =
    requiredSubStepFields?.noc_required?.is_visible === 1;
  const isNocRequiredForTrancheVisible =
    requiredSubStepFields?.noc_required_for_tranche?.is_visible === 1;
  const isRcTransferVisible =
    requiredSubStepFields?.rc_transfer?.is_visible === 1 &&
    visibilityObj?.name_transfer;

  const isInterRtoTransferVisible =
    requiredSubStepFields?.inter_rto_transfer?.is_visible === 1 &&
    visibilityObj?.inter_rto;

  // Check if any of the fields require verification
  const calculatedIsVerificationRequired =
    isRtoLocationVisible ||
    isRtoNameVisible ||
    isHptApplicableVisible ||
    isHpaApplicableVisible ||
    isNocRequiredVisible ||
    isNocRequiredForTrancheVisible ||
    isRcTransferVisible ||
    isInterRtoTransferVisible;

  const saveDetails = async () => {
    const stepDetails = getCompletedStepDetails(
      step_details,
      sub_stage,
      stepSelected
    );
    await axios_instance({
      url: "/dts/saveRTOParticulars",
      method: "POST",
      data: {
        finance_lead_id: +finance_lead_id,
        form: stepSelected,
        stage: +stage,
        sub_stage: +sub_stage,
        type: btnDraftType,
        step_details: stepDetails,
        insurance,
        bank_id,
        is_prepayment_raised,
        "hpt-applicable": state.HPT,
        "hpa-applicable": state.HPA,
        noc_amount_tranche: state.nocAmountTranche,
        "noc-required": state.NOCRequired,
        "name-transfer": state.isNameTransfer,
        "inter-rto": state.isInterRTOTransfer,
        disbursement_id: +id,
      },
    });
    await fetchCaseData();
  };

  const handleSaveAndNext = async () => {
    try {
      const checkHoldStatus = await checkHoldCase(
        finance_lead_id,
        maker_id,
        sub_stage
      );
      toast.dismiss();
      if (checkHoldStatus) {
        return toast.error(holdCaseMessage, { theme: "colored" });
      }
      if (
        !rtoParticularsValidate(
          state,
          setState,
          visibilityObj,
          requiredSubStepFields
        )
      ) {
        return toast.error("Please fill all mandatory fields", {
          theme: "colored",
        });
      }
      setDetailFormButtonClicked(true);
      await saveDetails();
      toast(<Message />);
      handleNextStep();
    } catch (error) {
    } finally {
      setDetailFormButtonClicked(false);
    }
  };

  const handleSaveAsDraft = async () => {
    try {
      const checkHoldStatus = await checkHoldCase(
        finance_lead_id,
        maker_id,
        sub_stage
      );
      toast.dismiss();
      if (checkHoldStatus) {
        return toast.error(holdCaseMessage, { theme: "colored" });
      }
      if (
        !rtoParticularsValidate(
          state,
          setState,
          visibilityObj,
          requiredSubStepFields
        )
      ) {
        return toast.error("Please fill all mandatory fields", {
          theme: "colored",
        });
      }
      setDetailFormButtonClicked(true);
      await saveDetails();
      toast(<Message />);
    } catch (error) {
    } finally {
      setDetailFormButtonClicked(false);
    }
  };

  const handleInputChange = (inputName, value, errorId) => {
    setState({ ...state, [inputName]: value, [errorId]: false });
  };

  return (
    <>
      <div
        className="table-responsive chklist-box-scroll mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
        data-mcs-theme="minimal-dark"
      >
        {isVerificationRequired && calculatedIsVerificationRequired ? (
          <div
            id="mCSB_1"
            className="mCustomScrollBox mCS-minimal-dark mCSB_vertical mCSB_outside"
          >
            <div
              id="mCSB_1_container"
              className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
            >
              <form id="rto_details_check">
                <table className="table table-bordered disburse-table">
                  <thead>
                    <tr>
                      <th width="76%" colSpan="2">
                        {panelTitle} - {stepTitle}
                      </th>
                      {checklist && <th width="24%">L1</th>}
                    </tr>
                  </thead>
                  <tbody className="form-table">
                    {isRtoLocationVisible && (
                      <tr>
                        <td>{requiredSubStepFields?.rto_location?.name}</td>
                        <td>
                          <span>
                            <label name="rto_location">
                              {caseDetails.rto_location
                                ? caseDetails.rto_location
                                : "--"}
                            </label>
                          </span>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="rto_location"
                            disabled={stepDetails.disableMaker}
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isRtoNameVisible && (
                      <tr>
                        <td>{requiredSubStepFields?.rto_name?.name}</td>
                        <td>
                          <span>
                            <label name="rto_name">
                              {caseDetails.rto_name
                                ? caseDetails.rto_name
                                : "--"}
                            </label>
                          </span>
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="rto_name"
                            disabled={stepDetails.disableMaker}
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isHptApplicableVisible && (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.hpt_applicable?.name}
                          isRequired={true}
                          className="rto"
                          name="hpt-applicable"
                          disabled={
                            requiredSubStepFields?.hpt_applicable
                              ?.is_editable === 1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={state.HPT === "1" ? true : false}
                          noChecked={state.HPT === "0" ? true : false}
                          onYesClicked={() =>
                            handleInputChange("HPT", "1", "showHPTError")
                          }
                          onNoClicked={() =>
                            handleInputChange("HPT", "0", "showHPTError")
                          }
                          showError={state.showHPTError}
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="hpt-applicable"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isHpaApplicableVisible && (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.hpa_applicable?.name}
                          isRequired={true}
                          className="rto"
                          name="hpa-applicable"
                          disabled={
                            requiredSubStepFields?.hpa_applicable
                              ?.is_editable === 1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={state.HPA === "1" ? true : false}
                          noChecked={state.HPA === "0" ? true : false}
                          onYesClicked={() =>
                            handleInputChange("HPA", "1", "showHPAError")
                          }
                          onNoClicked={() =>
                            handleInputChange("HPA", "0", "showHPAError")
                          }
                          showError={state.showHPAError}
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="hpa-applicable"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isNocRequiredVisible && (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.noc_required?.name}
                          isRequired={true}
                          className="rto"
                          name="noc-required"
                          disabled={
                            requiredSubStepFields?.noc_required?.is_editable ===
                            1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={state.NOCRequired === "1" ? true : false}
                          noChecked={state.NOCRequired === "0" ? true : false}
                          onYesClicked={() =>
                            handleInputChange(
                              "NOCRequired",
                              "1",
                              "showNocRequiredError"
                            )
                          }
                          onNoClicked={() =>
                            handleInputChange(
                              "NOCRequired",
                              "0",
                              "showNocRequiredError"
                            )
                          }
                          showError={state.showNocRequiredError}
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="noc-required"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    )}
                    {isNocRequiredForTrancheVisible && showNocTranche ? (
                      <tr>
                        <td>
                          {
                            requiredSubStepFields?.noc_required_for_tranche
                              ?.name
                          }
                          <span className="col-red">*</span>
                        </td>
                        <td>
                          {NocAmountTranche.length > 1 &&
                            caseDetails.dts_pay_count === 1 && (
                              <SingleSelectDropDown
                                dataArr={NocAmountTranche}
                                handleChange={(e) =>
                                  handleInputChange(
                                    "nocAmountTranche",
                                    e.target.value,
                                    "showNocAmountTrancheError"
                                  )
                                }
                                name="noc_amount_tranche"
                                disabled={
                                  requiredSubStepFields?.[
                                    "noc_required_for_tranche"
                                  ]?.is_editable === 1
                                    ? stepDetails.disableMaker
                                    : "disabled"
                                }
                                required={true}
                                value={state.nocAmountTranche}
                                className={
                                  state.showNocAmountTrancheError
                                    ? "errorInput"
                                    : ""
                                }
                                divClassName="form-group payment-dropdown-tranche-form"
                              />
                            )}
                          {NocAmountTranche.length > 1 &&
                            caseDetails.dts_pay_count > 1 && (
                              <div className="input-append date input-group input-sm">
                                <input
                                  type="text"
                                  name="noc_amount_tranche"
                                  id="noc_amount_tranche"
                                  className={`form-control ${
                                    state.showNocAmountTrancheError
                                      ? "errorInput"
                                      : ""
                                  }`}
                                  placeholder=""
                                  disabled={
                                    requiredSubStepFields?.[
                                      "noc_required_for_tranche"
                                    ]?.is_editable === 1
                                      ? stepDetails.disableMaker
                                      : "disabled"
                                  }
                                  value={
                                    state.nocAmountTranche
                                      ? state.nocAmountTranche
                                      : ""
                                  }
                                  onChange={(e) =>
                                    setState({
                                      ...state,
                                      nocAmountTranche: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            )}

                          {state.showNocAmountTrancheError ? (
                            <div
                              className="errorTxt"
                              id="error_noc_amount_tranche"
                            ></div>
                          ) : (
                            ""
                          )}
                        </td>
                        {checklist ? (
                          <FormTriggers
                            triggerName="noc_amount_tranche"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    ) : (
                      ""
                    )}

                    {isRcTransferVisible ? (
                      <tr>
                        <RadioButtons
                          label={requiredSubStepFields?.rc_transfer?.name}
                          isRequired={true}
                          className="rto"
                          name="name-transfer"
                          disabled={
                            requiredSubStepFields?.rc_transfer?.is_editable ===
                            1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={
                            state.isNameTransfer === "1" ? true : false
                          }
                          noChecked={
                            state.isNameTransfer === "0" ? true : false
                          }
                          onYesClicked={() =>
                            handleInputChange(
                              "isNameTransfer",
                              "1",
                              "showIsNameTransferError"
                            )
                          }
                          onNoClicked={() =>
                            handleInputChange(
                              "isNameTransfer",
                              "0",
                              "showIsNameTransferError"
                            )
                          }
                          showError={state.showIsNameTransferError}
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="name-transfer"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    ) : (
                      ""
                    )}

                    {isInterRtoTransferVisible ? (
                      <tr>
                        <RadioButtons
                          label={
                            requiredSubStepFields?.inter_rto_transfer?.name
                          }
                          isRequired={true}
                          className="rto"
                          name="inter-rto"
                          disabled={
                            requiredSubStepFields?.inter_rto_transfer
                              ?.is_editable === 1
                              ? stepDetails.disableMaker
                              : "disabled"
                          }
                          yesChecked={
                            state.isInterRTOTransfer === "1" ? true : false
                          }
                          noChecked={
                            state.isInterRTOTransfer === "0" ? true : false
                          }
                          onYesClicked={() =>
                            handleInputChange(
                              "isInterRTOTransfer",
                              "1",
                              "showIsInterRTOTransfer"
                            )
                          }
                          onNoClicked={() =>
                            handleInputChange(
                              "isInterRTOTransfer",
                              "0",
                              "showIsInterRTOTransfer}"
                            )
                          }
                          showError={state.showIsInterRTOTransfer}
                        />
                        {checklist ? (
                          <FormTriggers
                            triggerName="inter-rto"
                            triggerValues={dtsCheckpoints}
                            caseDetails={caseDetails}
                            disabled={stepDetails.disableMaker}
                          />
                        ) : (
                          ""
                        )}
                      </tr>
                    ) : (
                      ""
                    )}
                  </tbody>
                </table>
              </form>
            </div>
          </div>
        ) : (
          <div className="disburse-table no-form">
            There are no verification required in this section. Please click
            Next/Skip to proceed
          </div>
        )}
      </div>
      <FormButtons
        caseDetails={caseDetails}
        user={user}
        stepDetails={stepDetails}
        handleNextButtonClick={handleNextStep}
        handleSaveAndNext={handleSaveAndNext}
        handleSaveAsDraft={handleSaveAsDraft}
        isVerificationRequired={calculatedIsVerificationRequired}
        isReadOnlyUser={fieldValues.isReadOnlyUser}
      />
    </>
  );
};

export default RtoDetailsCheck;
